import React from 'react'
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import Text from '@components/Text';
import { themeDefault } from 'src/theme-revamp';
import Button from '@components/_Revamp/Button';

export interface MaintenanceModalProps {
  onNoClick?: () => void
  onYesClick?: () => void
}

function MaintenanceModal({ onYesClick, onNoClick, ...props }: MaintenanceModalProps) {
  return (
    <Container>
      <FormHeaderContainer>
        <FormHeaderTitleContainer marginHorizontal={"120px"}>
          <Text align={"center"} theme={themeDefault} className={HeaderTitleCss}>
            Sorry we're down for maintenance
          </Text>
        </FormHeaderTitleContainer>
        <FormHeaderDescriptionContainer>
          <Text theme={themeDefault} className={HeaderDescriptionCss}>
            We will be down for maintenance in 15 minutes. Sorry for the inconvenience, we’ll be back online shortly.
          </Text>
        </FormHeaderDescriptionContainer>
      </FormHeaderContainer>
      <FormContentContainer>
        <Button onClick={() => {
          if (onNoClick) {
            onNoClick();
          }
        }} width={"200px"} variant={'secondary'} theme={themeDefault} label={"No"}></Button>
        <Button onClick={() => {
          if (onYesClick) {
            onYesClick();
          }
        }} width={"200px"} variant={'default'} theme={themeDefault} label={"Yes"}></Button>
      </FormContentContainer>
    </Container>
  )
}

export default MaintenanceModal

const Container = styled.div`
 
`;

const HeaderTitleCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 767.98px) {
    font-size: 20px;
  }
`;

const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 48px;
  @media screen and (max-width: 767.98px) {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
  
`;
const FormContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  
  flex-direction: row;
  justify-content: center;
  @media screen and (min-width: 768px) {
    flex-direction: column;
    column-gap: 30px;
    flex-direction: row;
    justify-content: center;
  }
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px;
  }
`;

const HeaderDescriptionCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: 767.98px) {
    font-weight: 400;
  }
  
`;


export interface FormContainerProps {
  margin?: string;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}
